var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowNotificationDialog)?_c('div',{staticStyle:{"background-color":"#fff","padding-left":"2%","padding-right":"2%","padding-bottom":"20px"}},[_c('point-info-dialog',{attrs:{"device":_vm.device}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }